import EmailIcon from "./icons/EmailIcon";
import InstagramIcon from "./icons/InstagramIcon";
import LinkedinIcon from "./icons/LinkedinIcon";
import Logo from "./icons/Logo";
import UpArrowIcon from "./icons/UpArrowIcon";
import YoutubeIcon from "./icons/YoutubeIcon";

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

const Footer = () => {
  return (
    <footer className="bg-[#E0E0D6]">
      <div className="flex justify-between items-center px-[2.688rem] h-[313px]">
        <div className="flex gap-0 md:gap-32 flex-col md:flex-row">
          <div className="flex flex-col justify-between items">
            <div>
              <Logo className="mb-[10px] w-[180px] h-[40px] md:w-[265px] md:h-[65px]" />
              <p className="w-full max-w-[322px] font-extralight text-xs md:text-sm mb-4 md:mb-16">
                Cada peça carrega propósito, técnica e história. O equilíbrio
                entre design, sustentabilidade e impacto real.
              </p>
            </div>

            <p className="w-full max-w-[322px] font-extralight text-xs md:text-sm hidden md:flex">
              © 2025, Cria Casa. Todos os direitos reservados.
            </p>
          </div>

          <div className="flex flex-col justify-end">
            <div className="flex flex-col gap-2 mb-2 md:mb-11 font-extralight text-xs md:text-sm">
              <a href="callto:11 98820-8891">(11) 98820-8891</a>
              <a href="mailto:contato@criacasa.com.br">
                contato@criacasa.com.br
              </a>
              <p>Atendimento de segunda à sexta-feira, das 8h às 18h.</p>
            </div>

            <div className="font-extralight text-xs md:text-sm flex justify-between mb-2 md:mb-0">
              <a href="#">Política de Privacidade</a>

              <a href="#">Termos de Uso</a>
            </div>

            <p className="w-full max-w-[322px] font-extralight text-xs md:text-sm flex md:hidden">
              © 2025, Cria Casa. Todos os direitos reservados.
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-8 h-[219px]">
          <button
            type="button"
            className="flex justify-end md:justify-center items-center gap-2"
            onClick={scrollToTop}
          >
            <span className="text-sm md:text-xl hidden md:inline-block">
              VOLTAR AO TOPO
            </span>

            <UpArrowIcon className="hover:-translate-y-1 transition-all duration-500 ease-in-out" />
          </button>

          <ul className="flex gap-2 justify-end items-center flex-wrap">
            <li>
              <a href="mailto:contato@criacasa.com.br">
                <EmailIcon />
              </a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/@criacasa5589"
                aria-label="Youtube"
                target="_blank"
              >
                <YoutubeIcon />
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/company/criacasa/"
                aria-label="Linkedin"
                target="_blank"
              >
                <LinkedinIcon />
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/criacasa_/"
                aria-label="Instagram"
                target="_blank"
              >
                <InstagramIcon />
              </a>
            </li>
          </ul>
        </div>
      </div>
      <p className="text-center font-extralight text-xs md:text-sm pb-2">
        version 3.0
      </p>
    </footer>
  );
};

export default Footer;
